export const COLORS = {
  WHITE: "#ffffff",
  BLACK: "#000000",
  BRIGHT_YELLOW: "#FFFF04",
  GRAY: "#7B7B7B",
  RED: "#FF0000",
};

export const youtubeOpts = {
  height: "390",
  width: "640",
  playerVars: {
    autoplay: 1,
  },
};

export const pathName = {
  PLAYLIST: "playlist",
  M3U_PLAYLIST: "m3uPlaylist",
};

export const CATEGORY_ID = {
  FAVOURITES: "001",
  ALL: "all",
  RECENT_PLAYED: "003",
};

export const CATEGORY_TYPE = {
  FAVOURITES: "FAVOURITES",
  ALL: "ALL",
  RECENT_PLAYED: "RECENT_PLAYED",
};

export const SKIP_TIME = {
  FORWARD: 10,
  BACKWARD: 10,
};

export const FLOW_PLAYER_TOKEN = {
  TOKEN:
    "eyJraWQiOiJPUVNKb252dWF2VEciLCJ0eXAiOiJKV1QiLCJhbGciOiJFUzI1NiJ9.eyJjIjoie1wiYWNsXCI6MjIsXCJpZFwiOlwiT1FTSm9udnVhdlRHXCJ9IiwiaXNzIjoiRmxvd3BsYXllciJ9.kbpnpvItTz2m6sFo9VNFoQaOgPthWIvIOfLvcJbT8oR7QuFpDapxpkdnJTcnruRTAxoOQ-B8hdFjqgtWvjl7Hw",
  GENERAL_ID: "404a2bd5-8dd4-4114-b988-3b9732ffd6a4",
};

export const STATUS = {
  EXPIRED: "Expired",
  ERROR: '"error"',
};

export const M3U_TYPE = {
  FILE: "file",
  URL: "url",
};

export const API_STATUS = {
  STATUS_200: 200,
  STATUS_401: 401,
};

export const REGEX = {
  DECODE_M3U: /(tvg-id|tvg-link|tvg-name|tvg-logo|group-title)="([^"]+)"/g,
};

export const EXTERNAL_LINKS = {
  M3U_FILE_URL:
    "https://firebasestorage.googleapis.com/v0/b/smarterpro-7c899.appspot.com/o?name=",
};

export const orientationType = {
  PORTRAIT_PRIMARY: "portrait-primary",
  LANDSCAPE_PRIMARY: "landscape-primary",
  PORTRAIT_SECONDARY: "portrait-secondary",
  LANDSCAPE_SECONDARY: "landscape-secondary",
};

export const constant = {
  M3U_USERNAME: "m3uUserName",
};
